import { render } from "./HeroiconsSolidChevronDoubleLeft.vue?vue&type=template&id=72ac9ef1"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronDoubleLeft.vue"]])

export default __exports__